import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";

const AddNewProjectManagement = ({ Show, Hide, Title, getEditorProjectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const { studyId } = useParams()

  const addNewEditorProject = async () => {
    setButtonLoader(true)
    let userData = {};
    userData.studyId = studyId;
    userData.name = name;
    userData.description = description;
    let data = await editorProjectServices.addNewEditorProject(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      getEditorProjectData();
      setName("")
      setDescription("")
      Hide()
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Project Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="fontSize12"
              placeholder="Enter Project Name"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Description{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              className="fontSize12"
              placeholder="Enter Description"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={addNewEditorProject}
            disabled={buttonLoader || !name || !description}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              Title
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default AddNewProjectManagement;